// Logs apenas em desenvolvimento — nada é exposto no console em produção.
const dev = process.env.NODE_ENV !== "production";

export const logError = (...args) => { if (dev) console.error(...args); };
export const logDebug = (...args) => { if (dev) console.warn(...args); };
export const logWarn = (...args) => { if (dev) console.warn(...args); };
